import React from 'react';

import MetricList, {
  metricListPropTypes,
  metricsToOptions,
} from '../../_shared/components/MetricList';

// ActivityMetricDropdown
export const activityMetrics = {
  dau: 'DAU',
  downloads: 'Downloads',
};

const activityMetricsOptions = metricsToOptions(activityMetrics);
export const ActivityMetricDropdown = ({ selected, disabled, onChange }) => (
  <MetricList
    selected={selected}
    disabled={disabled}
    options={activityMetricsOptions}
    menuWidth={118}
    onChange={onChange}
  />
);

ActivityMetricDropdown.propTypes = metricListPropTypes;

export const segmentConcentrationMetrics = {
  high_frequency_ai_users: 'Segment Concentration — High-Frequency Users',
  medium_frequency_ai_users: 'Segment Concentration — Medium-Frequency Users',
};

const segmentConcentrationMetricsOptions = metricsToOptions(segmentConcentrationMetrics);
export const SegmentConcentrationDropdown = ({ selected, disabled, onChange }) => (
  <MetricList
    selected={selected}
    disabled={disabled}
    options={segmentConcentrationMetricsOptions}
    menuWidth={385}
    className="header-dropdown"
    onChange={onChange}
  />
);

SegmentConcentrationDropdown.propTypes = metricListPropTypes;

export const timeSpentMetrics = {
  high_frequency_ai_users: 'Time Spent — High-Frequency AI Users',
  medium_frequency_ai_users: 'Time Spent — Medium-Frequency AI Users',
};

const timeSpentMetricsOptions = metricsToOptions(timeSpentMetrics);
export const TimeSpentDropdown = ({ selected, disabled, onChange }) => (
  <MetricList
    selected={selected}
    disabled={disabled}
    options={timeSpentMetricsOptions}
    menuWidth={345}
    onChange={onChange}
  />
);

TimeSpentDropdown.propTypes = metricListPropTypes;

export const appImpactMetrics = {
  average_time_spent_per_dau: 'Avg Time Spent per DAU',
  average_sessions_per_dau: 'Average sessions per DAU',
};

const appImpactMetricsOptions = metricsToOptions(appImpactMetrics);
export const AppImpactDropdown = ({ selected, disabled, onChange }) => (
  <MetricList
    selected={selected}
    disabled={disabled}
    options={appImpactMetricsOptions}
    menuWidth={220}
    className="header-dropdown"
    onChange={onChange}
  />
);

AppImpactDropdown.propTypes = metricListPropTypes;
